import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles: ReturnType<typeof styled> = styled('div', {
  '.abyss-end-date-input-container': {
    '.abyss-date-picker-input-root': {
      '.abyss-layout-group': {
        visibility: 'hidden',
      },
    },
  },
});
